import type { PerRequestStats as PerRequestStatsData, StatSummary } from "../types/api";
import { MetricCard } from "./MetricCard";

interface PerRequestStatsProps {
  stats: PerRequestStatsData;
}

function StatGroup({
  title,
  summary,
  format,
}: {
  title: string;
  summary: StatSummary;
  format: (v: number) => string;
}) {
  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-slate-700">{title}</h4>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <MetricCard label="Avg" value={format(summary.avg)} />
        <MetricCard label="Min" value={format(summary.min)} />
        <MetricCard label="Max" value={format(summary.max)} />
        <MetricCard label="P95" value={format(summary.p95)} />
      </div>
    </div>
  );
}

const fmtUsd = (v: number) => `$${v.toFixed(4)}`;
const fmtInt = (v: number) => Math.round(v).toLocaleString();

export function PerRequestStats({ stats }: PerRequestStatsProps) {
  return (
    <div className="space-y-6">
      <p className="text-sm text-slate-600">
        Based on {stats.sampleCount.toLocaleString()} completed generations.
      </p>
      <StatGroup title="Cost per request" summary={stats.cost} format={fmtUsd} />
      <StatGroup title="Context length" summary={stats.contextLength} format={fmtInt} />
      <StatGroup title="Tokens in" summary={stats.tokensIn} format={fmtInt} />
    </div>
  );
}
